export const appHead = {"title":"onedesk","titleTemplate":"%s | onedesk","meta":[{"charset":"utf-8","name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no","charset":"utf-8"},{"name":"format-detection","content":"telephone=no, email=no, address=no, date=no"}],"link":[{"rel":"icon","type":"image/png","href":"/img/favicon_16.png","sizes":"16x16","key":"favicon-16"},{"rel":"icon","type":"image/png","href":"/img/favicon_32.png","sizes":"32x32","key":"favicon-32"},{"rel":"icon","type":"image/png","href":"/img/favicon_48.png","sizes":"64x64","key":"favicon-64"},{"rel":"icon","type":"image/png","href":"/img/favicon_192.png","sizes":"192x192","key":"favicon-192"}],"style":[],"script":[{"innerHTML":"(function(){try{if(localStorage.getItem('onedesk-color-theme')==='dark'){document.documentElement.dataset.theme='dark'}}catch(e){}})();","tagPosition":"head"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = true

export const hasParallelPlugins = false

export const hasPluginHooks = false

export const hasIslandOptOutPlugins = false